import * as actionTypes from "./actionTypes";
import axiosRequest from "../../axios-request/request.methods";

//bi fetched
export const fetchFinancialDetails = (payload) => {
  return {
    type: actionTypes.FETCH_FINANCIAL_DETAILS,
    formData: payload,
  };
};
// bi started
export const editFinancialDetailsStarted = () => {
  // //console.log(formData)
  return {
    type: actionTypes.FETCH_FINANCIAL_DETAILS_START,
  };
};

export const editFinancialDetailsSuccess = (formData, succMsg, res) => {
  return {
    type: actionTypes.FETCH_FINANCIAL_DETAILS_SUCESS,
    formData: formData,
    succMsg: "Proposal Updated Successfully",
    response: res,
  };
};

// export const fetchFinancialDetailsSuccess = (payload, apiPath) => {
//   return async (dispatch) => {
//     dispatch(editFinancialDetailsStarted());
//     axiosRequest.put(apiPath, payload).then((res) => {
//       //console.log(res);
//        dispatch(fetchFinancialDetails(res?.FinancialDetails));
//     });
//   };
// };

export const fetchFinancialDetailsSuccess = (payload, apiPath) => {
  return async (dispatch) => {
    dispatch(editFinancialDetailsStarted());
    try {
      const res = await axiosRequest.put(apiPath, payload);
      dispatch(fetchFinancialDetails(res?.FinancialDetails));
      return res; // Return the response
    } catch (err) {
      // Handle errors here if needed
      console.error("Error in fetchFinancialDetailsSuccess:", err);
      throw err; // Re-throw the error to propagate it to the caller
    }
  };
};

export const editFinancialDetailsFail = (errMsg) => {
  return {
    type: actionTypes.FETCH_FINANCIAL_DETAILS_FAIL,
    error: errMsg,
  };
};
